import { useFragment } from '@apollo/client/react'
import { LoadingSkeleton } from '@/components/base/loading-skeleton'
import { graphql } from '@/gql'
import { ReactFlowProvider } from '@xyflow/react'
import { Editor } from './editor'

export const ItemTypeFragment = graphql(`
  fragment ItemTypeDetail on ItemTypeType {
    id
    name
    connectorFamilies { id name connectorFamilyPins { id name role } }
    testSteps {
      id
      name
      testStepDependencies { id dependency { id } }
      positionX
      positionY
      steppable {
        __typename
        ... on NoopTestStepType { id result }
        ... on HipotTestStepType { id voltage connectorFamilyPin { id } }
        ... on ResistanceTestStepType { id connectorFamilyPinA { id } connectorFamilyPinB { id } }
        ... on ResistanceFourWireTestStepType { id connectorFamilyPinA { id } connectorFamilyPinB { id } }
        ... on CapacitanceTestStepType { id connectorFamilyPinA { id } connectorFamilyPinB { id } }
        ... on DiodeTestStepType { id connectorFamilyPinA { id } connectorFamilyPinB { id } }
        ... on TwistedPairTestStepType { id connectorFamilyPinA { id } connectorFamilyPinB { id } }
        ... on RcdTestStepType { id breakerCount phaseAngle tripCurrent }
        ... on LoadTestStepType { id loadCurrent }
        ... on WireTestStepType { id connectorFamilyPinA { id } connectorFamilyPinB { id } }
        ... on WireFourWireTestStepType { id connectorFamilyPinA { id } connectorFamilyPinB { id } }
        ... on LinkTestStepType { id connectorFamilyPinA { id } connectorFamilyPinB { id } }
      }
    }
  }
`)

interface Props {
  id: string
}

export const ItemType = ({ id }: Props) => {
  const { data, complete } = useFragment({
    fragment: ItemTypeFragment,
    from: { __typename: 'ItemTypeType', id },
  })

  if (!complete) return <LoadingSkeleton table />

  return (
    <>
      { data && <div className="flex flex-col grow">
        <ReactFlowProvider>
          <Editor connectorFamilies={ data.connectorFamilies } id={ id } testSteps={ data.testSteps } />
        </ReactFlowProvider>
      </div> }
    </>
  )
}
